import { FC } from 'react';
import { Heading } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ErrorBox } from '../../../../components/errorBox';
import { PageWrapper } from '../solceller';
import useStore from '../../../../hooks/useStore';
import { useBuildingData } from '../../../../hooks/useBuildingDetails/buildingDetailsHooks';
import { useEnergyAnalysis } from '../../../../hooks/useEnergyAnalysis';

import { OmBoligenForm } from './form';
import { fromUserInputToFormData } from './form/utils/dataMapper';
import { BuildingCard } from './buildingCard';
import { useOmBoligenSubmit } from './form/hooks/useOmBoligenSubmit';

export const OmBoligen: FC = () => {
  const { t } = useTranslation();
  const params = useParams();

  const { energyAnalysis } = useEnergyAnalysis(params.registrationId || '');
  const { building } = useBuildingData(energyAnalysis?.registrering.energiObjektId);

  const store = useStore();
  const userInput = store.getState().register.userInput;

  const defaultValues = fromUserInputToFormData({ userInput, registreringId: params.registrationId });
  const { onOmBoligenSubmit, isLoading, updateError } = useOmBoligenSubmit(params.registrationId || '');

  if (!building) {
    return null;
  }

  return (
    <PageWrapper>
      <Heading level={1} data-size="lg">
        {t('registrering.heading')}
      </Heading>
      <BuildingCard building={building} />
      <ErrorBox error={updateError} registrationId={params.registrationId} />
      <OmBoligenForm
        defaultValues={defaultValues}
        onSubmit={onOmBoligenSubmit}
        isLoading={isLoading}
        buildingId={building?.energiObjektId}
      />
    </PageWrapper>
  );
};
